module.exports = __webpack_public_path__ + "img/trash-gray.314eaff8.svg";